// BM-H398 - the review step. Hard stops and advisories come from the real
// engine result, in the engine's own words; nothing is re-implemented here.
// The two suppression paths (`ultimate_default_missing_or_silent` with
// supervisor approval, `rnrb_forfeit_acknowledged`) have no control on this
// screen or anywhere a client can reach.

import EngineResultView from "../EngineResultView";
import { Checkbox, QuestionRow, SectionIntro } from "./fields";
import { sectionLabel } from "./sectionRegistry";
import { countNotKnown } from "./willsPayload";

export default function ReviewScreen({ payload, update, engineResult, engineError }) {
  const decl = payload.submission.answers.s12_declaration || {};
  const setDecl = (patch) => update((d) => { d.submission.answers.s12_declaration = { ...decl, ...patch }; });
  const notKnown = countNotKnown(payload);
  const hardStops = engineResult?.flags?.hard_stops || [];

  return (
    <div data-testid="section-review">
      <SectionIntro title="Review and submit">
        Once you submit, your fee earner reviews your answers, drafts your will and sends it to you for review. Nothing is final until you have seen the draft and signed the will itself.
      </SectionIntro>

      {engineError && (
        <p data-testid="review-engine-error" role="status" style={{ fontSize: 14, border: "1px solid currentColor", borderRadius: 8, padding: 12 }}>{engineError}</p>
      )}

      <h3 style={{ fontSize: 16, margin: "8px 0" }}>Live checks</h3>
      <EngineResultView engineResult={engineResult} />

      {hardStops.length > 0 && (
        <div data-testid="review-hard-stops" style={{ margin: "12px 0 20px" }}>
          <p style={{ fontSize: 14 }}>Before you can submit, these items need to be resolved. Each one is in the engine's own words; a fee earner will call you about any you cannot change yourself.</p>
          <ul style={{ fontSize: 14, paddingLeft: 18 }}>
            {hardStops.map((h, i) => (
              <li key={`${h.code}-${i}`} data-testid={`review-hard-stop-${h.code}`}>
                <strong>{sectionLabel(h.triggered_at_section)}:</strong> {h.reason}
              </li>
            ))}
          </ul>
        </div>
      )}

      {notKnown > 0 && (
        <p data-testid="review-not-known-count" style={{ fontSize: 14 }}>
          You marked {notKnown} answer{notKnown === 1 ? "" : "s"} as not known. That is fine. Your fee earner will pick them up with you.
        </p>
      )}

      <div style={{ display: "grid", gap: 12, marginTop: 20 }}>
        <QuestionRow qid="s12_declaration.confirmed_reflects_wishes" label="Your confirmation">
          <Checkbox testid="review-confirm-wishes" checked={decl.confirmed_reflects_wishes} onChange={(v) => setDecl({ confirmed_reflects_wishes: v })} label="These answers reflect my wishes." />
        </QuestionRow>
        <QuestionRow qid="s12_declaration.confirmed_unpressured" label="Free choice">
          <Checkbox testid="review-confirm-unpressured" checked={decl.confirmed_unpressured} onChange={(v) => setDecl({ confirmed_unpressured: v })} label="I have answered freely and no one has pressured me." />
        </QuestionRow>
        <QuestionRow qid="s12_declaration.understands_draft_status" label="What happens next">
          <Checkbox testid="review-confirm-draft" checked={decl.understands_draft_status} onChange={(v) => setDecl({ understands_draft_status: v })} label="I understand a fee earner will review my answers and prepare a draft for me to check before anything is signed." />
        </QuestionRow>
      </div>
    </div>
  );
}

export function declarationComplete(payload) {
  const d = payload.submission.answers.s12_declaration || {};
  return d.confirmed_reflects_wishes === true && d.confirmed_unpressured === true && d.understands_draft_status === true;
}
